import CmsBaseClass from "@/helpers/cms/CmsBaseClass.js";

const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === `MacIntel` && navigator.maxTouchPoints > 1);

const IS_ANDROID = /Android/i.test(navigator.userAgent);

export default class MapIntegrations extends CmsBaseClass {
    constructor(integrations) {
        super(integrations);

        if (!this.wayfinding) {
            this.wayfinding = {};
        }
        const gps = this.wayfinding?.gps;
        if (gps === true || gps === false || gps == null || gps.enabled != null) {
            const gpsSettings = {
                enabled: gps === true || gps?.enabled === true,
                ios: gps === true || gps?.ios === true,
                android: gps === true || gps?.android === true
            };
            this.wayfinding.gps = {
                blueDotNavigation: {...gpsSettings},
                currentLocation: {...gpsSettings}
            };
        }

        this.wayfinding = this.mergeDefaults(this.wayfinding, {
            enabled: true,
            compass: false,
            gps: {
                blueDotNavigation: {
                    enabled: false,
                    ios: false,
                    android: true
                },
                currentLocation: {
                    enabled: false,
                    ios: false,
                    android: true
                }
            },
            pedometer: false,
            qrCode: false,
            qrCodeOnBoarding: true,
            accessibilityNavigation: false
        });
        if (this.wayfinding.gps.blueDotNavigation.enabled) {
            this.wayfinding.gps.currentLocation.enabled = true;
            if (this.wayfinding.gps.blueDotNavigation.ios) {
                this.wayfinding.gps.currentLocation.ios = true;
            }
            if (this.wayfinding.gps.blueDotNavigation.android) {
                this.wayfinding.gps.currentLocation.android = true;
            }
        }
        this.images360 = this.mergeDefaults(this.images360, {
            enabled: false,
            offsetAngle: 0
        });
    }

    isCompassEnabled() {
        return this.wayfinding.compass;
    }

    isGpsIntegrationEnabled(gpsIntegration) {
        if (!gpsIntegration.enabled) {
            return false;
        }

        if (IS_IOS) {
            return gpsIntegration.ios;
        }

        if (IS_ANDROID) {
            return gpsIntegration.android;
        }

        return false;
    }

    isBlueDotNavigationEnabled() {
        return this.isGpsIntegrationEnabled(this.wayfinding.gps.blueDotNavigation);
    }

    isCurrentLocationEnabled() {
        return this.isGpsIntegrationEnabled(this.wayfinding.gps.currentLocation);
    }

    isGpsEnabled() {
        return this.isBlueDotNavigationEnabled();
    }

    isPedometerEnabled() {
        return this.wayfinding.pedometer && this.isBlueDotNavigationEnabled();
    }

    isQrCodeEnabled() {
        return this.wayfinding.qrCode;
    }

    isQrCodeOnBoardingEnabled() {
        return this.wayfinding.qrCodeOnBoarding;
    }

    isAccessibilityNavigationEnabled() {
        return this.wayfinding.accessibilityNavigation;
    }

    isImages360Enabled() {
        return this.images360.enabled;
    }
}
